import React, { useEffect } from 'react';
// default
import { scrollToTop } from '../../utils';
import { useLanguage } from '../../LanguageContext';
import PoliticaComercialPescaMX from './PoliticsComercialPescaMX'
import PoliticaComercialPescaUS from './PoliticsComercialPescaUS'

const PoliticsComercialPesca = () => {

    useEffect(() => {
        scrollToTop();
    })
    const { translations, changeLanguage, language } = useLanguage();

    if (language === 'en-US') {
        return (
            //Exibe nada se estiver em inglês
            <section className="fale-conosco container">
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                    fontSize: '24px',
                    fontWeight: 'bold'
                }}>

                </div>
            </section>
        );
    }

    return (
        <>
            {language === 'es-MX' ? <PoliticaComercialPescaMX /> : <PoliticaComercialPescaUS />}
        </>
    );
}

export default PoliticsComercialPesca;